export class SpouseDetailModel {
  private spouseNameNric!: string;
  private spouseNricNo!: number;
  private spouseDob!: string;
  private spouseFinPassportNo!: string;
  private spouseOccupation!: string;
  private spouseNationality!: string;
  private nameOfEmployer!: string;
  private pias_rep_code!: string;

  constructor() { }
  getPiasrepCode(): string {
    return this.pias_rep_code;
  }
  setPiasrepCode(pias_rep_code: string) {
    this.pias_rep_code = pias_rep_code;
  }


  getSpouseNameNric(): string {
    return this.spouseNameNric;
  }
  setSpouseNameNric(spouseNameNric: string) {
    this.spouseNameNric = spouseNameNric;
  }

  getSpouseNricNo(): number {
    return this.spouseNricNo;
  }
  setSpouseNricNo(spouseNricNo: number) {
    this.spouseNricNo = spouseNricNo;
  }

  getSpouseDob(): string {
    return this.spouseDob;
  }
  setSpouseDob(spouseDob: string) {
    this.spouseDob = spouseDob;
  }

  getSpouseFinPassportNo(): string {
    return this.spouseFinPassportNo;
  }
  setSpouseFinPassportNo(spouseFinPassportNo: string) {
    this.spouseFinPassportNo = spouseFinPassportNo;
  }

  getSpouseOccupation(): string {
    return this.spouseOccupation;
  }
  setSpouseOccupation(spouseOccupation: string) {
    this.spouseOccupation = spouseOccupation;
  }

  getSpouseNationality(): string {
    return this.spouseNationality;
  }
  setSpouseNationality(spouseNationality: string) {
    this.spouseNationality = spouseNationality;
  }

  getNameOfEmployer(): string {
    return this.nameOfEmployer;
  }
  setNameOfEmployer(nameOfEmployer: string) {
    this.nameOfEmployer = nameOfEmployer;
  }

  toString() {
    return JSON.stringify({
      spouseNameNric: this.getSpouseNameNric(),
      spouseNricNo: this.getSpouseNricNo(),
      spouseDob: this.getSpouseDob(),
      spouseFinPassportNo: this.getSpouseFinPassportNo(),
      spouseOccupation: this.getSpouseOccupation(),
      spouseNationality: this.getSpouseNationality(),
      nameOfEmployer: this.getNameOfEmployer(),
      pias_rep_code:this.getPiasrepCode()

    });
  }

}




